import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useStateContext } from '../../../state/context'
import { setImmunizationPatient } from '../../../state/actions/actions'
import Pagination from '../../utils/Pagination'

const ChildImmunizationTable = () => {
    const dispatch = useDispatch()

    const { opdState, setOpdState } = useStateContext()

    const { all_patient_for_immunization } = useSelector((state) => state.nurse)

    const [currentData, setCurrentData] = useState([])

    return (
        <Fragment>
            <table className='border rounded w-full cursor-default'>
                <thead className=''>
                    <tr>
                        <th
                            scope='col'
                            className='text-sm font-medium text-gray-900 pr-[4em] px-4 py-4 text-left'
                        >
                            S/N
                        </th>

                        <th
                            scope='col'
                            className='text-sm font-medium text-gray-900 pr-[4em] px-4 py-4 text-left'
                        >
                            Patient Number
                        </th>
                        <th
                            scope='col'
                            className='text-sm font-medium text-gray-900 pr-[5em] py-4 text-left'
                        >
                            Full name
                        </th>

                        <th
                            scope='col'
                            className='text-sm font-medium text-gray-900 py-4 text-left'
                        >
                            Gender
                        </th>


                        <th
                            scope='col'
                            className='text-sm font-medium text-gray-900 py-4 text-left'
                        >
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {currentData?.map((item, index) => (
                        <tr
                            className='relative'
                            key={index}
                        >
                            <td className='px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900'>
                                {index + 1}
                            </td>
                            <td className='text-sm text-gray-900 font-light py-2 whitespace-nowrap'>
                                {item.patient_details.patient_number}         </td>
                            <td className='text-sm text-gray-900 font-light py-2 whitespace-nowrap'>
                                {item.patient.first_name}  {item.patient.last_name}
                            </td>
                            <td className='text-sm text-gray-900 font-light py-2 whitespace-nowrap'>
                                {item.patient_details.gender}
                            </td>
                            <td className=' text-sm text-gray-900 font-light py-2 whitespace-nowrap'>
                                <div className='flex space-x-4 relative '>
                                    <button
                                        type="button"
                                        className="inline-block px-6 py-2.5 bg-dark-green text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:bg-dark-green active:shadow-lg transition duration-500 ease"
                                        onClick={() => {
                                            const data = {
                                                patient_number: item.patient_details.patient_number,
                                                first_name: item.patient.first_name,
                                                last_name: item.patient.last_name,
                                                patient_id: item.patient.id,
                                                photo: item?.patient_details?.photo,
                                                address: item?.patient_details?.address,
                                                dob: item?.patient_details?.dob
                                            }

                                            dispatch(setImmunizationPatient({ data }))
                                            setOpdState({
                                                ...opdState,
                                                showChildImmunizationRecords: true

                                            })
                                        }}
                                    >
                                       Manage
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <Pagination
                data={all_patient_for_immunization}
                currentData={currentData}
                setCurrentData={setCurrentData}
            />
        </Fragment>
    )
}

export default ChildImmunizationTable